module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$hydrowareSecurityJS.canView_A('inventory') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Inventory"
    }
  })], 1) : _c('div', [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content pform"
  }, [(this.$hydrowareCommonJS.showInnerPageHeading) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "x_title"
  }, [_c('h2', [_c('b', [_vm._v(" Manage Inventory")])]), _vm._v(" "), _c('span', {
    staticClass: "inner_title_buttons"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.isaddding && _vm.$hydrowareSecurityJS.canAdd_A('inventory')) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.AddInventoryItem('addCompliance')
      }
    }
  }, [_vm._v("\n                        Add Inventory\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.isediting && _vm.$hydrowareSecurityJS.canEdit_A('inventory')) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateInventoryDetails('addCompliance')
      }
    }
  }, [_vm._v("\n                        Update Inventory\n                      ")]) : _vm._e()]), _vm._v(" "), ((_vm.isediting || _vm.isaddding) && !_vm.isDashboardView) ? _c('el-button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showCompliancevit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    staticStyle: {
      "font-size": "16px",
      "color": "white"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("\n                        Inventory List\n                      ")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isediting && !_vm.isaddding) ? _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "vue-tables-options"
    }
  }, [_c('v-client-table', {
    staticClass: "hydroware-table",
    attrs: {
      "data": _vm.Inventories,
      "columns": _vm.compliance_columns,
      "options": _vm.optionstable
    },
    scopedSlots: _vm._u([{
      key: "NameAndBrand",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "clear": "both"
          }
        }, [_c('div', {
          staticClass: "hydroware-text-label"
        }, [_vm._v("Name:")]), _vm._v("\n                        " + _vm._s(props.row.InventoryName) + "\n                        "), _c('br'), _vm._v(" "), _c('div', {
          staticClass: "hydroware-text-label"
        }, [_vm._v("Brand:")]), _vm._v("\n                        " + _vm._s(props.row.Brand) + " \n                      ")])]
      }
    }, {
      key: "CategoryAndType",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "clear": "both"
          }
        }, [_c('div', {
          staticClass: "hydroware-text-label"
        }, [_vm._v("Category:")]), _vm._v("\n                        " + _vm._s(props.row.Category) + "\n                        "), _c('br'), _vm._v(" "), _c('div', {
          staticClass: "hydroware-text-label"
        }, [_vm._v("Type:")]), _vm._v("\n                        " + _vm._s(props.row.Type) + "\n                      ")])]
      }
    }, {
      key: "Actions",
      fn: function(props) {
        return [_c('div', [_c('hydroware-viewOrEdit-button', {
          attrs: {
            "EV": _vm.$hydrowareSecurityJS.showViewOrEditOrNeitherButton_A('inventory')
          },
          on: {
            "click": function($event) {
              return _vm.editcol(props)
            }
          }
        }), _vm._v(" "), (_vm.$hydrowareSecurityJS.canDelete_A('inventory')) ? _c('hydroware-delete-button', {
          on: {
            "click": function($event) {
              return _vm.del(props)
            }
          }
        }) : _vm._e()], 1)]
      }
    }], null, false, 784585383)
  }, [(this.$hydrowareSecurityJS.canAdd_A('inventory')) ? _c('hydroware-add-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isediting && !_vm.isaddding),
      expression: "!isediting && !isaddding"
    }],
    attrs: {
      "slot": "afterLimit"
    },
    on: {
      "click": function($event) {
        return _vm.addCompliancevit()
      }
    },
    slot: "afterLimit"
  }) : _vm._e()], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.isediting || _vm.isaddding) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('el-form', {
    ref: "addCompliance",
    staticClass: "hydroware-editNoEdit",
    attrs: {
      "disabled": _vm.$hydrowareSecurityJS.disableDataEntry_A('inventory', _vm.isAddingOrEditing),
      "model": _vm.Inventory,
      "rules": _vm.rules,
      "label-position": _vm.labelPosition,
      "spellcheck": "false"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12 col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Type:",
      "prop": "InventoryTypeId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "--Select a Type--"
    },
    on: {
      "change": function($event) {
        return _vm.Getcategory(_vm.Inventory.InventoryTypeId)
      }
    },
    model: {
      value: (_vm.Inventory.InventoryTypeId),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "InventoryTypeId", $$v)
      },
      expression: "Inventory.InventoryTypeId"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.TypeId,
      attrs: {
        "label": item.TypeName,
        "value": item.TypeId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Category:",
      "prop": "InventoryCategoryId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "--Select a Category--"
    },
    on: {
      "change": function($event) {
        return _vm.getInventory(_vm.Inventory.InventoryCategoryId)
      }
    },
    model: {
      value: (_vm.Inventory.InventoryCategoryId),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "InventoryCategoryId", $$v)
      },
      expression: "Inventory.InventoryCategoryId"
    }
  }, _vm._l((_vm.categories), function(item) {
    return _c('el-option', {
      key: item.CategoryId,
      attrs: {
        "label": item.CategoryName,
        "value": item.CategoryId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Inventory:",
      "prop": "InventoryId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "--Select an Inventory--"
    },
    model: {
      value: (_vm.Inventory.InventoryId),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "InventoryId", $$v)
      },
      expression: "Inventory.InventoryId"
    }
  }, _vm._l((_vm.cinventories), function(item) {
    return _c('el-option', {
      key: item.InventoryId,
      attrs: {
        "label": item.ItemName,
        "value": item.InventoryId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Make:",
      "prop": "Brand"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 40
    },
    model: {
      value: (_vm.Inventory.Brand),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "Brand", $$v)
      },
      expression: "Inventory.Brand"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Model:",
      "prop": "Model"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 40
    },
    model: {
      value: (_vm.Inventory.Model),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "Model", $$v)
      },
      expression: "Inventory.Model"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Color:",
      "prop": "Color"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 40
    },
    model: {
      value: (_vm.Inventory.Color),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "Color", $$v)
      },
      expression: "Inventory.Color"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Size:",
      "prop": "Size"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 40
    },
    model: {
      value: (_vm.Inventory.Size),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "Size", $$v)
      },
      expression: "Inventory.Size"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Description:",
      "prop": "Description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": 400
    },
    model: {
      value: (_vm.Inventory.Description),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "Description", $$v)
      },
      expression: "Inventory.Description"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Suppliers:",
      "prop": "Suppliers"
    }
  }, [_c('el-select', {
    staticClass: "hydroware",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "Please Select",
      "filterable": ""
    },
    model: {
      value: (_vm.Inventory.Suppliers),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "Suppliers", $$v)
      },
      expression: "Inventory.Suppliers"
    }
  }, _vm._l((_vm.suppliers), function(item) {
    return _c('el-option', {
      key: item.SupplierId,
      staticStyle: {
        "color": "black!important"
      },
      attrs: {
        "label": item.CompanyName,
        "value": item.SupplierId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Lead Time:",
      "prop": "LeadTime"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 40
    },
    model: {
      value: (_vm.Inventory.LeadTime),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "LeadTime", $$v)
      },
      expression: "Inventory.LeadTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Usage Rate:",
      "prop": "UsageRate"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 40
    },
    model: {
      value: (_vm.Inventory.UsageRate),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "UsageRate", $$v)
      },
      expression: "Inventory.UsageRate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Date:",
      "prop": "Date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "MM-dd-yyyy",
      "placeholder": "Pick a date",
      "editable": false
    },
    on: {
      "blur": _vm.hydroware_picker_hasBlurred
    },
    model: {
      value: (_vm.Inventory.Date),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "Date", $$v)
      },
      expression: "Inventory.Date"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Quantity:",
      "prop": "Quantity"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 40
    },
    model: {
      value: (_vm.Inventory.Quantity),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "Quantity", $$v)
      },
      expression: "Inventory.Quantity"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "UoM:",
      "prop": "UoM"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 40
    },
    model: {
      value: (_vm.Inventory.UoM),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "UoM", $$v)
      },
      expression: "Inventory.UoM"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Storage Location:",
      "prop": "StorageLocation"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 40
    },
    model: {
      value: (_vm.Inventory.StorageLocation),
      callback: function($$v) {
        _vm.$set(_vm.Inventory, "StorageLocation", $$v)
      },
      expression: "Inventory.StorageLocation"
    }
  })], 1)], 1), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('span', {
    staticClass: "inner_title_buttons"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [((_vm.isaddding)) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.AddInventoryItem('addCompliance')
      }
    }
  }, [_vm._v("\n                      Add Inventory\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.isediting && _vm.$hydrowareSecurityJS.canEdit_A('inventory')) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateInventoryDetails('addCompliance')
      }
    }
  }, [_vm._v("\n                      Update Inventory\n                    ")]) : _vm._e()]), _vm._v(" "), ((_vm.isediting || _vm.isaddding)) ? _c('el-button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showCompliancevit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    staticStyle: {
      "font-size": "16px",
      "color": "white"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("\n                        Inventory List\n                      ")])]) : _vm._e()], 1)], 1)]) : _vm._e()], 1)])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5631dc17"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HealthSafety/inventory.vue
// module id = 815
// module chunks = 1